export const fieldsEn = {
  amount: 'Amount',
  contract: 'Contract',
  currency: 'Currency',
  dateFrom: 'Period from',
  dateTo: 'Period to',
  from: 'From',
  paymentIndicator: 'Payment type',
  paymentMethod: 'Payment method',
  paymentStatus: 'Payment status',
  transactionStatus: 'Payment status',
  transactionNumber: 'Transaction number (order id)',
  period: 'Date range',
  reportName: 'Report name',
  role: 'Role',
  status: 'Status',
  to: 'To',
  notificationMethod: 'Notification method',
  orderId: 'Order ID',
  operationId: 'Operation ID',
  publicId: 'Public ID',
  sessionId: 'Session ID',
  orderIdApm: 'Order ID',
  clientIdCrypto: 'Client ID',
  includeBulkPayouts: 'Include bulk payouts',
} as const;

export type TFieldsKeys = keyof typeof fieldsEn;

export const fieldsRu: Record<TFieldsKeys, string> = {
  amount: 'Сумма',
  contract: 'Контракт',
  currency: 'Валюта',
  dateFrom: 'Период от',
  dateTo: 'Период до',
  from: 'От',
  paymentIndicator: 'Признак платежа',
  paymentMethod: 'Способ оплаты',
  paymentStatus: 'Статус платежа',
  transactionStatus: 'Статус платежа',
  transactionNumber: 'Номер транзакции (order id)',
  period: 'Период',
  reportName: 'Название отчета',
  role: 'Роль',
  status: 'Статус',
  to: 'До',
  notificationMethod: 'Способ уведомления',
  orderId: 'ID заказа',
  operationId: 'ID операции',
  publicId: 'Публичный идентификатор',
  sessionId: 'Идентификатор сессии',
  orderIdApm: 'Номер транзакции (order id)',
  clientIdCrypto: 'Идентификатор клиента',
  includeBulkPayouts: 'Включать массовые операции',
} as const;
